<template>
  <path
    d="M12 22.0002C13.1 22.0002 14 21.1002 14 20.0002H9.99999C9.99999 21.1002 10.89 22.0002 12 22.0002ZM18 16.0002V11.0002C18 7.93024 16.36 5.36024 13.5 4.68024V4.00024C13.5 3.17024 12.83 2.50024 12 2.50024C11.17 2.50024 10.5 3.17024 10.5 4.00024V4.68024C7.62999 5.36024 5.99999 7.92024 5.99999 11.0002V16.0002L4.70999 17.2902C4.07999 17.9202 4.51999 19.0002 5.40999 19.0002H18.58C19.47 19.0002 19.92 17.9202 19.29 17.2902L18 16.0002Z"
  />
</template>
